/**
 * Тип алерта в модальном окне авторизации.
 * Соответствует легаси-аргументу `waitForLoginPopup(type)`
 */
export enum EAlertType {
  Favorites = 'favorites',
  Chats = 'chats',
  Hide = 'hide',
}

export interface IAuthModalViewData {
  headingType: string;
}

/**
 * Параметры ручки шапки `/v3/open-auth-modal/`.
 * Дублирует контракт микрофронтенда шапки — своего сгенерированного нет
 */
export interface IOpenAuthModalParameters {
  /**
   * Перезагрузить страницу после успешной авторизации
   *
   * @default true
   */
  autoRefresh?: boolean;
  /**
   * Алерт в модальном окне
   *
   * @default null
   */
  alert?: EAlertType | null;
  /**
   * Использовать вид модального окна по умолчанию
   *
   * @default false
   */
  useDefaultView?: boolean;
  /**
   * Данные для отображения модального окна
   *
   * @default null
   */
  viewData?: IAuthModalViewData | null;
  /**
   * Источник открытия модального окна, используется в аналитике
   *
   * @default null
   */
  source?: string | null;
}

export interface IHeaderMicrofrontendAPI {
  /**
   * Открывает модальное окно авторизации в микрофронтенде шапки
   */
  openAuthModal(parameters?: IOpenAuthModalParameters): Promise<void>;
}

export interface IMicrofrontendsAPI {
  header: IHeaderMicrofrontendAPI;
}
